import { useAuth } from "@/context/AuthContext";
import { ConfBadge, PageHeader } from "@/components/shared";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { useEffect, useState } from "react";
import { toast } from "sonner";

export default function Profile() {
  const { user, access, tenants } = useAuth();
  const [emailOn, setEmailOn] = useState(true);

  useEffect(() => {
    api.get("/notifications/preferences").then(({ data }) => setEmailOn(data.email_notifications)).catch(() => {});
  }, []);

  return (
    <div className="space-y-10">
      <PageHeader testid="profile-header" eyebrow="Account" title="Profile & preferences" description={user?.email} />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="panel p-6">
          <p className="label-caps">Identity</p>
          <dl className="mt-4 space-y-3 text-sm">
            <div className="flex justify-between gap-4"><dt className="text-muted-foreground">Name</dt><dd>{user?.name}</dd></div>
            <div className="flex justify-between gap-4"><dt className="text-muted-foreground">Title</dt><dd>{user?.title || "—"}</dd></div>
            <div className="flex justify-between gap-4"><dt className="text-muted-foreground">Platform admin</dt><dd>{user?.is_platform_admin ? "Yes" : "No"}</dd></div>
            <div className="flex justify-between gap-4"><dt className="text-muted-foreground">Engagements</dt><dd>{tenants.length}</dd></div>
          </dl>
        </div>
        <div className="panel p-6">
          <p className="label-caps">Current engagement scope</p>
          <dl className="mt-4 space-y-3 text-sm">
            <div className="flex justify-between gap-4"><dt className="text-muted-foreground">Roles</dt><dd>{(access?.roles || []).join(", ") || "—"}</dd></div>
            <div className="flex justify-between gap-4"><dt className="text-muted-foreground">Frameworks</dt><dd>{(access?.frameworks || []).join(", ") || "—"}</dd></div>
            <div className="flex items-center justify-between gap-4"><dt className="text-muted-foreground">Clearance</dt><dd><ConfBadge level={access?.confidentiality_max || 1} /></dd></div>
          </dl>
          <div className="mt-6 flex flex-wrap gap-2">
            {(access?.actions || []).map((a) => (
              <span key={a} className="border border-border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider">{a}</span>
            ))}
          </div>
        </div>
        <div className="panel p-6">
          <p className="label-caps">Notification preferences</p>
          <label className="mt-5 flex items-center justify-between gap-4 text-sm">
            Email copies of in-app notifications
            <Switch
              data-testid="profile-email-switch"
              checked={emailOn}
              onCheckedChange={async (v) => {
                setEmailOn(v);
                await api.put("/notifications/preferences", { email_notifications: v }).catch((e) => toast.error(errMsg(e)));
              }}
            />
          </label>
        </div>
      </div>
    </div>
  );
}
